// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"179":"i18n","510":"dayjs"}[chunkId] || chunkId) + ".js";
};